const isDev = process.env.NODE_ENV === 'development'

const postfix = isDev ? 'graphql/website' : 'backend/graphql/website'

export const WEBSITE_SCHEMA = `${process.env.GATSBY_SITEURL}/${postfix}`
